import React, { useState } from "react";
import {
  IconArrowBarToRight,
  IconCalendarWeek,
  IconLayoutDashboard,
  IconLock,
  IconPackage,
  IconPhoto,
  IconUserBolt,
  IconUserShield,
  IconYoga,
} from "@tabler/icons-react";
import styles from "./nav.module.scss";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../../store/AuthContext";
import { useToast } from "../../components/toast";
import ConfirmModal from "../../components/modal/ConfirmModal";
import logo from "../../assets/images/logo.png";
import api from "../../api";

export default function Sidebar() {
  const [showModal, setShowModal] = useState(false);
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const toast = useToast();

  const { removeAuth } = useAuth();

  const navData = [
    // {
    //   key: "/dashboard",
    //   label: "Дашбоард",
    //   icon: <IconLayoutDashboard size={20} />,
    // },
    {
      key: "/schedule",
      label: "Хуваарь",
      icon: <IconCalendarWeek size={20} />,
    },
    {
      key: "/room",
      label: "Өрөө",
      icon: <IconYoga size={20} />,
    },
    {
      key: "/bundle",
      label: "Багц",
      icon: <IconPackage size={20} />,
    },
    {
      key: "/banner",
      label: "Баннер",
      icon: <IconPhoto size={20} />,
    },
    {
      key: "/user",
      label: "Хэрэглэгчид",
      icon: <IconUserBolt size={20} />,
    },
    {
      key: "/staff",
      label: "Ажилчид",
      icon: <IconUserShield size={20} />,
    },
    {
      key: "/role",
      label: "Эрх",
      icon: <IconLock size={20} />,
    },
  ];

  const logoutHandler = async () => {
    const res = await api.logout();
    // console.log("logout res --->", res);
    if (res.status === 200) {
      await removeAuth();
      toast("Системээс гарлаа", "info");
    } else {
      // console.error("Logout error:", res);
      toast("Системээс гарахад алдаа гарлаа", "error");
    }
  };

  return (
    <div className={styles.wrapper}>
      <div>
        <a href="/dashboard">
          <img src={logo} alt="logo" className={styles.logo} />
        </a>
        <div className={styles.nav}>
          {navData.map((e, i) => (
            <div
              key={i}
              className={`${styles.navItem} ${
                pathname.startsWith(e.key) ? styles.active : ""
              }`}
              onClick={() => navigate(e.key)}
            >
              {e.icon}
              {e.label}
            </div>
          ))}
        </div>
      </div>

      <div className={styles.logout} onClick={() => setShowModal(true)}>
        Гарах <IconArrowBarToRight size={22} />
      </div>

      <ConfirmModal
        showModal={showModal}
        setShowModal={setShowModal}
        submitHandler={logoutHandler}
        title="Итгэлтэй байна уу?"
      />
    </div>
  );
}
